import { FieldValues } from "../FieldValues";
import { Field } from "../Field";

export abstract class FieldValuesResolver {
  abstract resolve(field:Field, obj:any):FieldValues
}